var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13119",
    "data-name": "Group 13119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.799,
    height: 16.722,
    viewBox: "0 0 23.799 16.722",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5012",
    "data-name": "Rectangle 5012",
    width: 23.799,
    height: 16.722,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12745",
    "data-name": "Group 12745",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45354",
    "data-name": "Path 45354",
    d: "M11.907,0A12.616,12.616,0,0,1,23.659,7.73a1.5,1.5,0,0,1,0,1.263,12.244,12.244,0,0,1-9.471,7.517A12.614,12.614,0,0,1,.136,9,1.545,1.545,0,0,1,.157,7.687,12.479,12.479,0,0,1,9.438.228a6.126,6.126,0,0,1,.772-.115c.565-.046,1.131-.076,1.7-.112m-.021,13.119A4.754,4.754,0,1,0,7.143,8.36a4.737,4.737,0,0,0,4.742,4.759",
    transform: "translate(0 0)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45355",
    "data-name": "Path 45355",
    d: "M129.863,80.1a2.392,2.392,0,1,1-2.4,2.365,2.413,2.413,0,0,1,2.4-2.365",
    transform: "translate(-117.953 -74.129)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.fc46afd2bc10e214e33626c4adfe3b98.svg";
export { ForwardRef as ReactComponent };